import React, { PropTypes } from 'react';
import ManipButtons from '../ManipButtons';

const DisinfectionItem = ({
  manip,
  onUpdated,
  onDeleted,
  disabled = false,
}) => (
  <tr>
    <ManipButtons
      manip={manip}
      onUpdated={onUpdated}
      onDeleted={onDeleted}
      hideHistory={false}
      disabled={disabled}
    />
    <td>{manip.number}</td>
    <td>{manip.product_name}</td>
    <td>{manip.manip_name}</td>
    <td>{manip.comp_product_name}</td>
    <td>{manip.comp_manip_name}</td>
  </tr>
);

DisinfectionItem.propTypes = {
  manip: PropTypes.object.isRequired,
  onUpdated: PropTypes.func.isRequired,
  onDeleted: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DisinfectionItem;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/types/DisinfectionItem.js